module.exports = __webpack_public_path__ + "img/ji_gou.ea493d6d.png";